<template>
  <div class="main-page">
    <div class="container">
      <!-- Hero building backdrop in its own layer so it can tip back from its
           base on scroll (see GSAP block below + .hero-bg in main.scss). -->
      <div class="hero-bg" ref="heroBg" aria-hidden="true"></div>

      <div class="descriptions" v-reveal.stagger>
        <div class="bg-description">
          <h1>{{ $t('home.heroTitle') }}</h1>
        </div>
        <div class="sm-description">
          <p class="insmall_description">{{ $t('home.heroSubtitle') }}</p>
        </div>
      </div>
      <div class="boshqarmalar">
          <ul v-reveal.stagger>
            <li>
              <router-link class="boshqarma-link" to="/faoliyat/oquv-metodik">
                <img src="../../assets/img/logos/oquv_metodik.svg" :alt="$t('home.featureOquvMetodik')"> <h6>{{ $t('home.featureOquvMetodik') }}</h6>
              </router-link>
            </li>
            <li>
              <router-link class="boshqarma-link" to="/faoliyat/talim-normativlari">
                <img src="../../assets/img/logos/talim_normativlari.svg" :alt="$t('home.featureNormativlar')"> <h6>{{ $t('home.featureNormativlar') }}</h6>
              </router-link>
            </li>
            <li>
              <router-link class="boshqarma-link" to="/faoliyat/baholash-monitoring">
                <img src="../../assets/img/logos/baholash_monitoring.svg" :alt="$t('home.featureBaholash')"> <h6>{{ $t('home.featureBaholash') }}</h6>
              </router-link>
            </li>
            <li>
              <router-link class="boshqarma-link" to="/faoliyat/raqamli-savodxonlik">
                <img src="../../assets/img/logos/raqamli_savodxonlik.svg" :alt="$t('home.featureRaqamli')"> <h6>{{ $t('home.featureRaqamli') }}</h6>
              </router-link>
            </li>
          </ul>
      </div>
    </div>

    <YangiliklarElonlar />
    <PrezidentPart v-reveal />
    <StatistikaPart />
    <MediaPart v-reveal />
    <RaqamliPortal v-reveal />
    <FoydaliHavolalar v-reveal />
    <FooterPart />
  </div>
</template>


<script>

import YangiliklarElonlar from "../02yangiliklar_va_elonlar/YangiliklarElonlar.vue"
import PrezidentPart from "../03prezident/PrezidentPart.vue"
import StatistikaPart from "../03prezident/StatistikaPart.vue"
import MediaPart from "../04media/MediaPart.vue"
import RaqamliPortal from "../05raqamli_portal/RaqamliPortal.vue"
import FoydaliHavolalar from "../06foydali_havolalar/FoydaliHavolalar.vue"
import FooterPart from "../07footer/FooterPart.vue"

import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
gsap.registerPlugin(ScrollTrigger)

export default {
  components: { YangiliklarElonlar, PrezidentPart, StatistikaPart, MediaPart, RaqamliPortal, FoydaliHavolalar, FooterPart },

  // ── Hero "zoom & fade" effect ───────────────────────────────────────────────
  // As the hero scrolls away the building grows from its base and fades out
  // (transform-origin: bottom; see .hero-bg in main.scss). Desktop + motion-OK
  // only. To REVERT: delete this mounted/beforeUnmount block, the
  // <div class="hero-bg"> in the template, and the .hero-bg CSS.
  mounted() {
    const mm = window.matchMedia
    const reduce = mm && mm('(prefers-reduced-motion: reduce)').matches
    const small = mm && mm('(max-width: 768px)').matches
    if (reduce || small) return
    const el = this.$refs.heroBg
    if (!el) return
    this._heroTl = gsap.timeline({
      scrollTrigger: {
        trigger: '.main-page .container',
        start: 'top top',
        end: 'bottom top',
        scrub: 0.4
      }
    })
    this._heroTl
      .to(el, { scale: 2.8, ease: 'none', duration: 1 }, 0)       // grow from the base
      .to(el, { opacity: 0, ease: 'none', duration: 0.7 }, 0.3)   // hold, then fade out
  },
  beforeUnmount() {
    if (this._heroTl) {
      if (this._heroTl.scrollTrigger) this._heroTl.scrollTrigger.kill()
      this._heroTl.kill()
      this._heroTl = null
    }
  }
};
</script>

<style lang="scss">
@import url(../../styles/components/01main/main.scss);
</style>